<template>
  <div class="container body-container">
    <page-heading>
      <div slot="title">Your reports</div>
    </page-heading>
    <reports-table></reports-table>
  </div>
</template>

<script>
import PageHeading from '@/components/app/PageHeading';
import ReportsTable from '@/components/reports/reportsindex/Table';

export default {
  components: {
    PageHeading,
    ReportsTable,
  },
};
</script>

<!-- <style scoped>
  .content-area {
    min-height: calc(100vh - 235px);
  }
</style> -->
